import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { baseUrlEncoderGreyScale, dataUrlToGray } from '../../utils/baseurl.encoder';
const myUpload = require('vue-image-crop-upload').default;

@Component({
    components: {
        'crop-uploader': myUpload
    }
})
export default class LPPropertyInfoForm extends Vue {
    public title: string = 'LPPropertyInfoForm';

    @Prop({
        default: () => {
            return {
                propertyType: '',
                bedrooms: '',
                bedroomsPlus: '',
                washrooms: '',
                garages: '',
                picture: '',
            };
        }
    })
    public data: any;

    public imgModal = false;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public propertyInfoRules: any = {
        propertyType: [
            { required: true, message: 'The propertyType cannot be empty', trigger: 'blur' }
        ],
    };

    public async cropSuccess(imgDataUrl: any, field: any) {
        // this.data.picture = await dataUrlToGray(imgDataUrl, 460, 300);
        this.data.picture = await imgDataUrl;
    }
}
